import * as React from "react";
import { Link, Trans, useTranslation } from "gatsby-plugin-react-i18next";
import { getStaticT } from "../i18n/staticTranslations";

const EIN = "03-0515223";
const STATEMENT_DESCRIPTOR = "IHSAN / CENTER_OF_IHSAN_JZK";
// Set to false, rebuild, and deploy to remove the DBA disclosure in every locale.
const SHOW_DBA_DISCLOSURE = true;
const DBA_LEGAL_NAME = "Multicultural Mosaic Foundation";

export default function Footer() {
  const { t, i18n } = useTranslation();

  return (
    <footer style={{ borderTop: "1px solid rgba(18,23,20,0.10)", marginTop: 40 }}>
      <div className="container" style={{ paddingTop: 32, paddingBottom: 32 }}>
        <div className="grid" style={{ alignItems: "start" }}>
          <div className="card col-6">
            <div style={{ fontFamily: "var(--font-heading)", fontSize: 20, fontWeight: 700 }}>
              {t("brand.name")}
            </div>
            <p style={{ margin: "10px 0 0", color: "var(--color-muted)" }}>{t("brand.mission")}</p>
            <p style={{ margin: "10px 0 0", color: "var(--color-muted)" }}>
              {t("footer.note")}
            </p>
          </div>

          <div className="card col-3">
            <div style={{ fontWeight: 800, marginBottom: 10 }}>{t("footer.quickLinks")}</div>
            <div style={{ display: "grid", gap: 10 }}>
              <Link to="/circle-of-ihsan">{t("cta.join")}</Link>
              <Link to="/about">{t("nav.about")}</Link>
              <Link to="/programs">{t("nav.programs")}</Link>
              <Link to="/services">{t("nav.services")}</Link>
              <Link to="/events">{t("nav.events")}</Link>
              <Link to="/blog">{t("nav.blog")}</Link>
              <Link to="/contact">{t("nav.contact")}</Link>
              <Link to="/privacy">{t("footer.privacy")}</Link>
              <Link to="/terms">{t("footer.terms")}</Link>
            </div>
          </div>

          <div className="card col-3">
            <div style={{ fontWeight: 800, marginBottom: 10 }}>{t("footer.getInTouch")}</div>
            <div style={{ display: "grid", gap: 10, color: "var(--color-muted)" }}>
              <div>
                <div style={{ fontWeight: 700, color: "var(--color-text)" }}>{t("footer.locationTitle")}</div>
                <div>{t("footer.locationValue")}</div>
              </div>
              <div>
                <div style={{ fontWeight: 700, color: "var(--color-text)" }}>{t("footer.emailTitle")}</div>
                <a href="mailto:salaam@centerofihsan.com">salaam@centerofihsan.com</a>
              </div>
            </div>
          </div>
        </div>

        <div style={{ paddingTop: 18, color: "var(--color-muted)", fontSize: 13, display: "grid", gap: 6 }}>
          <div>
            © {new Date().getFullYear()} {t("brand.name")} · {t("footer.rights")}
          </div>
          {SHOW_DBA_DISCLOSURE && (
            <div>
              <Trans
                i18nKey="footer.dba"
                // Cached page data can predate this key; keep a localized fallback with the bundle.
                defaults={getStaticT(i18n.language)("footer.dba")}
                values={{ orgName: t("brand.name"), legalName: DBA_LEGAL_NAME }}
                components={[<bdi />, <bdi dir="ltr" />]}
              />
            </div>
          )}
          <div>{t("footer.nonprofit", { ein: EIN, orgName: t("brand.name") })}</div>
          <div>
            <Trans
              i18nKey="footer.statementDescriptor"
              values={{ descriptor: STATEMENT_DESCRIPTOR }}
              components={[<span dir="ltr" />]}
            />
          </div>
        </div>
      </div>
    </footer>
  );
}
